const useGetManagerTeam = () => {
	// NOTE: returns the team the user manages, or nothing - the user context is kept in sync by usePermissionSync
	const getManagerTeam = async (email: string, token: string) => {
		const response = await fetch(`/api/health/api/teams/manager/${email}`, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		})

		if (response.status === 204) return

		const json = await response.json()

		if (!response.ok) throw new Error(json.error)

		if (!json || json.length === 0) return

		return json[0]
	}

	return { getManagerTeam }
}

export default useGetManagerTeam
